import {
  clearPreviewOverride,
  getPreviewOverrideBranch,
  isPreviewOverrideActive,
} from '@openphone/web-config'
import { useState } from 'react'

import Banner from '@src/component/Banner'
import Typography from '@ui/Typography'

import * as styles from './PreviewEnvironmentBanner.css'

function PreviewEnvironmentBanner() {
  // Session-only: intentionally not persisted, so the banner comes back on
  // the next reload rather than staying dismissed while a preview override
  // is still active.
  const [dismissed, setDismissed] = useState(false)

  if (!isPreviewOverrideActive() || dismissed) {
    return null
  }

  const branch = getPreviewOverrideBranch()

  const handleExit = () => {
    clearPreviewOverride()
    window.location.reload()
  }

  return (
    <Banner isDismissible type="blue" onDismiss={() => setDismissed(true)}>
      <Typography variant="footnote" component={'span'}>
        {branch
          ? `You are connected to a backend pr preview environment (${branch}).`
          : 'You are connected to a backend pr preview environment.'}{' '}
        <button className={styles.exitButton} onClick={handleExit}>
          Disconnect from preview environment
        </button>
      </Typography>
    </Banner>
  )
}

export default PreviewEnvironmentBanner
